import React, { useContext, useState } from "react";
import { FlexContainer, LottieLoadingIndicator, Toast } from "src/components";
import { CardList } from "src/components";
import { EmailCampaignsContext } from "../EmailCampaignsContext";
import { purchaseNewCap } from "../api/newCampaignApi";

export default function EmailProPayment({ plan, onClose, onOpenUpgradeModal, onPurchaseSuccess, onProcessingChange }) {
    const { user } = useContext(EmailCampaignsContext);
    const token = user?.token;
    
    const [loading, setLoading] = useState(false);

    const handlePurchaseWithExisting = async (selectedCard) => {
        if (!selectedCard) {
            Toast.error("No payment method selected");
            return;
        }

        setLoading(true);
        if (onProcessingChange) {
            onProcessingChange(true);
        }
        let didComplete = false;
        try {
            await purchaseNewCap(plan.uuid, selectedCard);
            Toast.success("Payment Successful!");
            await onPurchaseSuccess();
            didComplete = true;
        } catch (err) {
            console.error(err);
            Toast.error("Payment failed: " + err.getApiErrorDetails().message);
        } finally {
            setLoading(false);
            if (!didComplete && onProcessingChange) {
                onProcessingChange(false);
            }
        }
    };

    if (loading) return <LottieLoadingIndicator />;

    return (
        <FlexContainer direction="column" gap="20px">
            <CardList
                token={token}
                onBackClicked={onClose}
                onPurchaseClicked={(selectedCard) => {
                    if (selectedCard) {
                        handlePurchaseWithExisting(selectedCard);
                    } else {
                        onOpenUpgradeModal();
                    }
                }}
                onDeleteClicked={null}
            />
        </FlexContainer>
    );
}
